// Shipment type constants (Vue 2 — JS equivalent of types/shipment.ts)

export const SHIPMENT_STATUSES = [
  'DRAFT', 'ESTIMATED', 'CREATED', 'PICKUP_CREATED',
  'IN_TRANSIT', 'DELIVERED', 'CANCELLED',
]

export const LABEL_TYPES = ['EightFiveByEleven', 'FourBySix']

export const PACKAGING_TYPES = ['package', 'envelope', 'courier-pack', 'freight']

export const WEIGHT_UNITS = ['kg', 'lb']

export const PICKUP_LOCATIONS = [
  'OutsideDoor', 'FrontPorch', 'Office', 'SideDoor', 'Basement',
  'FrontDesk', 'BetweenDoors', 'Security', 'Counter', 'Lobby',
  'Mailbox', 'GateHouse', 'Desk', 'Kiosk', 'Shipping', 'ProShop',
  'FrontDoor', 'Receiving', 'Reception', 'BackDoor', 'Lab',
  'MailRoom', 'Garage', 'Pharmacy', 'ServiceCounter', 'PartsDepartment',
]
